import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './categories-model.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const fetched = (state, { data }) => ({
  ...state,
  categories: data,
  categoryItemsToUpdateOrder: [],
  subCategoryItemsToUpdateOrder: [],
});

const fetchedMenuCategories = (state, { data }) => ({
  ...state,
  menuCategories: data,
});

const openModal = (state, { category }) => ({
  ...state,
  isModalOpen: true,
  categoryToUpdate: category,
});

const closeModal = (state) => ({
  ...state,
  isModalOpen: false,
  categoryToUpdate: INITIAL_STATE.categoryToUpdate,
});

const updateOrder = (state, { oldIndex, newIndex }) => {
  const categoriesToUpdate = [...state.categories];
  const movedCategory = categoriesToUpdate.splice(oldIndex, 1)[0];
  categoriesToUpdate.splice(newIndex, 0, movedCategory);
  const updatedCategories = categoriesToUpdate.map((item, index) => ({
    ...item,
    order: index + 1,
  }));
  return {
    ...state,
    categories: [...updatedCategories],
    categoryItemsToUpdateOrder: updatedCategories.map((item) => ({
      id: item.id,
      order: item.order,
    })),
  };
};

const updateSubCategoriesOrder = (state, { oldIndex, newIndex, parentId }) => {
  const categoriesToUpdate = [...state.categories];
  const parentCategoryIndex = categoriesToUpdate.findIndex((item) => item.id === parentId);
  if (parentCategoryIndex === -1) return state;

  // Clonar a categoria pai e suas subcategorias
  const parentCategory = {
    ...categoriesToUpdate[parentCategoryIndex],
    subCategories: [...categoriesToUpdate[parentCategoryIndex].subCategories],
  };

  // Remover e adicionar a subcategoria na nova posição
  const [movedSubCategory] = parentCategory.subCategories.splice(oldIndex, 1);
  parentCategory.subCategories.splice(newIndex, 0, movedSubCategory);

  // Atualizar a ordem das subcategorias
  const updatedSubCategories = parentCategory.subCategories.map((item, index) => ({
    ...item,
    order: index + 1,
  }));

  // Atualizar a lista de categorias com a categoria pai atualizada
  const updatedCategories = categoriesToUpdate.map((item, index) =>
    index === parentCategoryIndex
      ? { ...parentCategory, subCategories: updatedSubCategories }
      : item,
  );

  return {
    ...state,
    categories: updatedCategories,
    subCategoryItemsToUpdateOrder: [
      ...state.subCategoryItemsToUpdateOrder.filter(
        (pending) => !updatedSubCategories.some((item) => item.id === pending.id),
      ),
      ...updatedSubCategories.map((item) => ({ id: item.id, order: item.order })),
    ],
  };
};

const openSubCategoryModal = (state, { categoryId, subCategory }) => ({
  ...state,
  isSubCategoryModalOpen: true,
  categoryId,
  subCategoryToUpdate: subCategory,
});

const closeSubCategoryModal = (state) => ({
  ...state,
  isSubCategoryModalOpen: false,
  categoryId: INITIAL_STATE.categoryId,
  subCategoryToUpdate: INITIAL_STATE.subCategoryToUpdate,
});

export const { Types, Creators } = createActions({
  // Categories Actions
  categoriesFetched: ['data'],
  categoriesFetchedMenuCategories: ['data'],
  categoriesUpdateOrder: ['oldIndex', 'newIndex'],
  categoriesOpenModal: ['category'],
  categoriesCloseModal: [],
  // Categories Async Actions
  categoriesFetchAsync: [],
  categoriesDeleteAsync: ['id'],
  categoriesUpdateOrdersAsync: [],
  categoriesAddSubCategoryAsync: ['categoryId', 'data'],
  categoriesCreateAsync: ['data'],
  categoriesUpdateAsync: ['data'],
  categoriesFetchMenuCategories: [],
  // Subcategories Actions
  subCategoriesOpenModal: ['categoryId', 'subCategory'],
  subCategoriesCloseModal: [],
  subCategoriesUpdateOrder: ['oldIndex', 'newIndex', 'parentId'],
  subCategoriesUpdateAsync: ['data'],
  subCategoriesDeleteAsync: ['id'],
});

export default createReducer(INITIAL_STATE, {
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.CATEGORIES_FETCHED]: fetched,
  [Types.CATEGORIES_OPEN_MODAL]: openModal,
  [Types.CATEGORIES_CLOSE_MODAL]: closeModal,
  [Types.CATEGORIES_UPDATE_ORDER]: updateOrder,
  [Types.CATEGORIES_FETCHED_MENU_CATEGORIES]: fetchedMenuCategories,
  [Types.SUB_CATEGORIES_UPDATE_ORDER]: updateSubCategoriesOrder,
  [Types.SUB_CATEGORIES_OPEN_MODAL]: openSubCategoryModal,
  [Types.SUB_CATEGORIES_CLOSE_MODAL]: closeSubCategoryModal,
});
